import type { ResourceState } from '@domain/schemas/contract.schema';

import {
  ARCHIVED_TRANSITIONS,
  DRAFT_TRANSITIONS,
  FINAL_TRANSITIONS,
  FIRM_ORDER_TRANSITIONS,
  PUBLISHED_TRANSITIONS,
  REVIEW_TRANSITIONS,
} from './constants';
import type { TransitionConfigMap } from './types';

type Config = Partial<Record<ResourceState, TransitionConfigMap>>;

export const TRANSITION_CONFIG: Config = {
  DRAFT: DRAFT_TRANSITIONS,
  FIRM_ORDER: FIRM_ORDER_TRANSITIONS,
  REVIEW: REVIEW_TRANSITIONS,
  FINAL: FINAL_TRANSITIONS,
  PUBLISHED: PUBLISHED_TRANSITIONS,
  ARCHIVED: ARCHIVED_TRANSITIONS,
};
